import * as x from '../helpers/xmlHelpers';

export class NeighborhoodDetail {
    constructor(doc)
    {
		this.label = null
		this.neighborhoodName = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.neighborhoodName = x.getStringElement(doc, "./ns:NeighborhoodName");
   }
}

export class Neighborhood {
    constructor(doc)
    {
		this.label = null
		this.neighborhoodDetail = null
		var node;

		this.label = x.getStringAttribute(doc,"xlink:label");
		node = x.selectSingleNode(doc, "./ns:NEIGHBORHOOD_DETAIL");
		if (node !== null)
				this.neighborhoodDetail = new NeighborhoodDetail(node);
   }
}

